// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"viewDealSlip_previewContainer__2mH4M","dropdownButton":"viewDealSlip_dropdownButton__1lm3y","download":"viewDealSlip_download__BgmEI"};